export class ProductStock {
    amount: number;
    last_updated: string;
    dirty: boolean; 
}


// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/product_stock.ts